import { useEffect } from 'react';
import type { MutableRefObject } from 'react';
import type { DomEnvironment } from '../types';
import { defaultDomEnvironment } from '../dom-environment';
import type { UseTypeaheadNavigationResult } from './use-typeahead-navigation';

type UseDropdownFocusRingParams = {
    isOpen: boolean;
    listboxId: string;
    navigation: UseTypeaheadNavigationResult;
    inputRef: MutableRefObject<HTMLInputElement | null>;
    environment?: DomEnvironment;
};

const optionDomId = (listboxId: string, index: number) => `${listboxId}-option-${index}`;

const useDropdownFocusRing = ({ isOpen, listboxId, navigation, inputRef, environment = defaultDomEnvironment }: UseDropdownFocusRingParams) => {
    useEffect(() => {
        if (!isOpen) return;
        const requestedIndex = navigation.consumeFocusRequest();
        if (typeof requestedIndex === 'undefined') return;
        if (requestedIndex === -1) {
            environment.focusElement(inputRef.current);
            return;
        }
        const element = environment.getElementById(optionDomId(listboxId, requestedIndex));
        if (element) {
            environment.focusElement(element);
        }
    }, [environment, inputRef, isOpen, listboxId, navigation]);
};

export { useDropdownFocusRing, optionDomId };
export type { UseDropdownFocusRingParams };
